import LoaderDotted from './loaderDotted'
export default LoaderDotted
